import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '@/permission' // permission control 

Vue.use(ElementUI);


Vue.config.productionTip = false

new Vue({
  el:'#app',
  router,
  render: h => h(App)
})
